import { useSrpContext } from '@/src/contexts'
import { useTranslations } from 'next-intl'

import FareHighlights from './fareHighlights'

const FareHighlightsWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const fareSummary = sections?.whenToBook?.fareSummary
    const heroStats = sections?.hero?.stats
    if (!fareSummary?.available && !heroStats) return null

    const stats = []

    if (fareSummary?.cheapestMonth) {
        stats.push({ label: t('cheapestMonth'), value: fareSummary.cheapestMonth })
    }
    if (fareSummary?.cheapestDay) {
        stats.push({ label: t('cheapestDay'), value: fareSummary.cheapestDay })
    }
    if (fareSummary?.minFare) {
        stats.push({ label: t('startingFrom'), value: `${fareSummary.minFare} ${fareSummary.currency}` })
    }
    if (fareSummary?.maxFare) {
        stats.push({ label: t('upTo'), value: `${fareSummary.maxFare} ${fareSummary.currency}` })
    }
    if (heroStats?.lowestFareAirline) {
        stats.push({ label: t('cheapestAirline'), value: heroStats.lowestFareAirline })
    }
    if (heroStats?.weeklyFlights) {
        stats.push({ label: t('weeklyFlights'), value: String(heroStats.weeklyFlights) })
    }
    if (heroStats?.flightDuration) {
        stats.push({ label: t('flightDuration'), value: heroStats.flightDuration })
    }
    if (heroStats?.topAirlineNames?.length) {
        stats.push({ label: t('airlinesOnRoute'), value: String(heroStats.topAirlineNames.length) })
    }

    if (stats.length === 0) return null

    return <FareHighlights stats={stats} />
}

export default FareHighlightsWrapper
